export default function (): string {
  const userAgent = window.navigator.userAgent;
  let os = 'Unknown';

  if (userAgent.includes('Win')) os = 'windows';
  if (userAgent.includes('Mac')) os = 'macos';
  if (userAgent.includes('X11')) os = 'unix';
  if (userAgent.includes('Linux')) os = 'linux';
  if (userAgent.includes('Android')) os = 'android';
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) os = 'ios';

  return os;
}
